import { Badge } from "@/components/ui/badge";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface StatusBadgeProps {
  status: string;
}

const config: Record<string, { className: string; animate?: boolean }> = {
  pending: {
    className: "bg-warning/15 text-warning border-warning/30",
    animate: true,
  },
  running: {
    className: "bg-warning/15 text-warning border-warning/30",
    animate: true,
  },
  completed: {
    className: "bg-success/15 text-success border-success/30",
  },
  failed: {
    className: "bg-destructive/15 text-destructive border-destructive/30",
  },
};

export function StatusBadge({ status }: StatusBadgeProps) {
  const { t } = useTranslation("common");
  const c = config[status] || { className: "" };
  // Known statuses → localized; unknown statuses fall back to the raw value.
  const label = config[status] ? t(`status.${status}`) : status;

  return (
    <Badge variant="outline" className={`gap-1.5 font-medium ${c.className}`}>
      {c.animate && <Loader2 className="h-3 w-3 animate-spin" />}
      {label}
    </Badge>
  );
}
